/**
 * What the file viewer steps through, and its copy (verbatim from the files
 * spec where the spec names it).
 */
import type { ThreadFileKind } from '@discovr/types';

/** One file the viewer can show: an attachment, or a moment's frame. */
export interface ViewerItem {
  /** Fetched through the file source; `NO_FILE_ID` when only a local preview exists. */
  fileId: string;
  /** Shown in the header, and the name Download saves the file under — unless `downloadStem` is set. */
  name: string;
  /**
   * For an item whose name isn't a file name (a moment's frame, `Frame at
   * 0:08`): Download saves it as this stem plus the extension of the bytes'
   * type, e.g. `frame-0-08.webp`.
   */
  downloadStem?: string;
  kind: ThreadFileKind;
  /** Bytes; `UNKNOWN_FILE_SIZE` for a moment's frame. */
  size: number;
  /** An optimistic bubble's local preview, shown instead of fetching. */
  localUrl?: string;
  /** The line under the lightbox, e.g. `Annotated frame · 0:56`; a file's name and size when absent. */
  caption?: string;
}

export const DOWNLOAD_LABEL = 'Download';
export const CLOSE_LABEL = 'Close';
export const GO_TO_FRAME_LABEL = 'Go to frame';
export const ANNOTATED_FRAME_LABEL = 'Annotated frame';
/** Between the parts of the lightbox's caption: `Annotated frame · 0:56`, `brief.pdf · 2.4 MB`. */
export const CAPTION_SEPARATOR = ' · ';
export const PREVIOUS_FILE_LABEL = 'Previous file';
export const NEXT_FILE_LABEL = 'Next file';
/** The spinner's accessible name while a file loads. */
export const LOADING_FILE_LABEL = 'Loading file';
export const LOAD_FAILED_LABEL = "Couldn't load this file";
export const RETRY_LABEL = 'Retry';
